import { PaymentStatus } from './enums/PaymentStatus'
import Order from '../order/Order'
import PaymentJson from './interfaces/PaymentJson'

export default class Payment {
  status: PaymentStatus
  order: Order

  constructor(status: PaymentStatus, order: Order) {
    this.status = status
    this.order = order
  }

  static fromJson(data: PaymentJson) {
    return new this(data.status, Order.fromJson(data.order))
  }
}
